import { MouseEvent } from 'react';

import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IcDotSpread } from '@/assets/images';
import { VehicleInvolvementList } from '@/models';

import { getActiveLicensePlate } from './licensePlate.utils';

const licensePlate = (): Partial<GridColDef> => ({
  sortable: false,
  renderCell: (params) => getActiveLicensePlate(params.row)?.number || '-',
  valueGetter: (_, row) => getActiveLicensePlate(row)?.number,
});

const licensePlateState = (): Partial<GridColDef> => ({
  sortable: false,
  renderCell: (params) => getActiveLicensePlate(params.row)?.state || '-',
  valueGetter: (_, row) => getActiveLicensePlate(row)?.state,
});

const color = (): Partial<GridColDef> => ({
  sortable: false,
  renderCell: (params) => params.row.color || '-',
});

const make = (): Partial<GridColDef> => ({
  sortable: false,
  renderCell: (params) => params.row.make || '-',
});

const model = (): Partial<GridColDef> => ({
  sortable: false,
  renderCell: (params) => params.row.model || '-',
});

const disposition = (): Partial<GridColDef> => ({
  sortable: false,
  renderCell: (params) =>
    params.row?.disposition
      ? VehicleInvolvementList[
          params.row.disposition as keyof typeof VehicleInvolvementList
        ]
      : '',
});

const isVerified = (): Partial<GridColDef> => ({
  sortable: false,
  renderCell: (params) => (params.row.isVerified ? 'Verified' : 'Unverified'),
  valueGetter: (_, row) => (row.isVerified ? 'Verified' : 'Unverified'),
});

const actions = (
  openMenu?: (event: MouseEvent<HTMLButtonElement>, row: any) => void,
): Partial<GridColDef> => ({
  sortable: false,
  filterable: false,
  renderCell: (params) => (
    <IconButton
      aria-label="actions"
      onClick={(event) => {
        event.stopPropagation();
        openMenu?.(event, params.row);
      }}
    >
      <IcDotSpread />
    </IconButton>
  ),
});

export const sharedVehicleCols = (
  openMenu?: (event: MouseEvent<HTMLButtonElement>, row: any) => void,
) => {
  return {
    licensePlate,
    licensePlateState,
    color,
    make,
    model,
    disposition,
    isVerified,
    actions: () => actions(openMenu),
  };
};
